import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { CaretDownOutlined } from '@ant-design/icons';

import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import { FilterType } from './filterPopover';

import styles from './index.module.less';
import { useRouter } from 'next/router';

const MAX_SHOW_DATA = 5;
const StartCateegorizeButton = ({
  labelList,
  label,
  order_column,
  onChangeFliterType,
}: {
  labelList: { k: string; v: string }[];
  label: string;
  order_column: FilterType;
  onChangeFliterType: (type: FilterType) => void;
}) => {
  const { t } = useTranslation('common');
  const { width } = useScreenSize();

  const router = useRouter();
  const [showAll, setShowAll] = useState(MAX_SHOW_DATA);

  // const isMobil = width < 915;

  useEffect(() => {
    if (width > 0) {
      if (
        labelList?.length > MAX_SHOW_DATA &&
        width > 915 &&
        labelList.findIndex((v) => v.k === label) < MAX_SHOW_DATA
      ) {
        if (showAll === MAX_SHOW_DATA) return;
        setShowAll(MAX_SHOW_DATA);
      } else {
        setShowAll(undefined);
      }
    }
  }, [labelList, width, label]);

  // 弹窗组件

  return (
    <div className={styles.categoriza}>
      {/* {isMobil && (
        <FilterPopover type={order_column} onChange={(type) => onChangeFliterType(type)} />
      )} */}
      <div className={styles.container}>
        {/* {!isMobil && (
          <FilterPopover type={order_column} onChange={(type) => onChangeFliterType(type)} />
        )} */}
        <>
          <div
            className={classNames(styles.container__item, !label && styles.active)}
            onClick={() => router.push({ pathname: '/top-instagram' })}
          >
            {t('ALL')}
          </div>
          {labelList?.slice(0, showAll).map((item) => (
            <div
              key={item?.k}
              onClick={() => router.push({ pathname: `/top-instagram/${encodeURIComponent(item?.k)}` })}
              className={classNames(styles.container__item, label === item?.k && styles.active)}
            >
              {item?.v}
            </div>
          ))}
          {labelList?.length > MAX_SHOW_DATA && showAll === MAX_SHOW_DATA && (
            <div
              className={styles.container__item}
              onClick={() => setShowAll((prev) => (prev === MAX_SHOW_DATA ? undefined : MAX_SHOW_DATA))}
            >
              {t('more')} <CaretDownOutlined />
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default StartCateegorizeButton;
